import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../../components/layout/Header";
import ProfileSidebar from "../../layout/ProfileSidebar";
import { Helmet } from "react-helmet";
import api from "../../../api";

export default function Ligningsmester() {
  // State
  const [levelProgress, setLevelProgress] = useState([]);
  const [profile, setProfile] = useState("");
  const [showFact, setShowFact] = useState(false);
  const [isSliding, setIsSliding] = useState(false);
  const [isSlidingBack, setIsSlidingBack] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);
  const [activeButton, setActiveButton] = useState(true)
  
  // Fetch profile data
    // Level progress
    useEffect(() => {
      fetch("https://matly-backend.onrender.com/api/user/get_level_progress/", {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem("access")}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          console.log("Level progress:", data); 
          setLevelProgress(data);
        })
        .catch((err) => {
          console.error("Error fetching level progress:", err);
        });
    }, []);

    // Badge data
    useEffect(() => {
      api.get("profile/")
        .then((res) => {
          setProfile(res.data);
        })
        .catch((err) => {
          console.error("Error loading profile:", err);
        });
      }, []);


  return (
    <div className="relative pageGameMenu">
      <Helmet>
        <title>ligningsmesteren | matly</title>
      </Helmet>
      <Header />
      <div className="relative z-0 contentRow">
        <ProfileSidebar />

        {/* Main content */}
        <div className="card">
          {/* Mathematician card */}
          {showFact && (
            <button
              aria-label="Luk kort"
              onClick={() => {
                setShowFact(false);
                setIsSliding(false);
                setIsFlipped(false);
                setIsSlidingBack(true);   // trigger slide-back animation
                setTimeout(() => setIsSlidingBack(false), 300);
              }}
              className="absolute inset-0 -m-4 z-30 backdrop-blur-[2px] rounded-3xl"
            />
          )}
          <img
            src="/images/cards/al-khwarizmi.png"
            alt="Al-Khwarizmi card"
            onClick={() => {
              if (!showFact) {
                // First click: bring card out with slide
                setShowFact(true);
                setIsSliding(true);
                setTimeout(() => setIsSliding(false), 260);
              } else {
                // Card is already up: open Wikipedia page
                window.open("https://en.wikipedia.org/wiki/Muhammad_ibn_Musa_al-Khwarizmi", "_blank");
              }
            }}
            className={[
              "absolute cursor-pointer transition-all duration-200 ease-out",
              showFact
                ? (
                    isSliding
                      ? [
                          // Phase 1: slide right to peek out
                          "w-48 -z-10",
                          "top-16 -right-8 translate-x-48",
                          "rotate-[-1deg] shadow-xl"
                        ].join(" ")
                      : [
                          // Phase 2: move to center and enlarge
                          "w-72 z-40",
                          "top-16 -right-8 -translate-x-40",
                          "scale-110 rotate-0 shadow-4xl"
                        ].join(" ")
                  )
                : (
                    isSlidingBack
                      ? [
                          // Slide-back animation
                          "w-48 -z-10",
                          "top-16 -right-8 translate-x-48",
                          "rotate-[-1deg] shadow-xl"
                        ].join(" ")
                      : [
                          // Resting: tucked under the white card
                          "w-48 -z-10",
                          "top-16 -right-8",
                          "hover:translate-x-12",
                          "rotate-[-2deg]"
                        ].join(" ")
                  )
            ].join(" ")}
          />
          {/* Back of card (PNG) */}
          {/*
          <img
            src="/images/al-khwarismi_back.png"
            alt="Al-Khwarizmi card back"
            onClick={() => { setIsFlipped(false); }}
            className={[
              // Hide entirely if not flipped
              !isFlipped ? "hidden" : "",
              "absolute cursor-pointer transition-all duration-300 ease-out",
              showFact
                ? (
                    isSliding
                      ? [
                          // Phase 1: slide right to peek out (match front)
                          "w-48 -z-10",
                          "top-16 -right-8 translate-x-48",
                          "rotate-[-1deg] shadow-xl"
                        ].join(" ")
                      : [
                          // Phase 2: move to center and enlarge (match front)
                          "w-72 z-40",
                          "top-16 -right-8 -translate-x-40",
                          "scale-110 rotate-0 shadow-4xl"
                        ].join(" ")
                  )
                : (
                    isSlidingBack
                      ? [
                          "w-48 -z-10",
                          "top-16 -right-8 translate-x-48",
                          "rotate-[-1deg] shadow-xl"
                        ].join(" ")
                      : [
                          // Resting: tucked under the white card (match front)
                          "w-48 -z-10",
                          "top-16 -right-8",
                          "hover:translate-x-12",
                          "rotate-[-2deg]"
                        ].join(" ")
                  )
            ].join(" ")}
          />
          */}
            
          {/* Intro */}
          <div className="contentRow gameIntro">
            <div className="contentCol">
              <h1> Ligningsmesteren</h1>
              <p className="text-md font-light">Er du træt af at ligninger altid dukker op og besværliggøre matematik-timer lige meget hvilket emne I er igang med? Så giv dig i kast med <strong>ligningsmesteren</strong> og gør ligninger til en leg. Helt bogstaveligt. Med ligningsmester-mærket på jakken bliver samtlige emner MEGET nemmere.</p>
            </div>
          </div>
          
          {/* Levels */}
          <div className="flex flex-col w-full mt-8 items-center justify-center gap-4">
            
            {/* Level 1 */}
            <div className="gamesWindow">

              {/* Image and button */}
              <div className="flex flex-col items-start min-w-[170px] relative mb-4">
                <h2 className="text-lg font-nunito font-semibold text-center w-full">
                  kapitel 1
                </h2>
                {/* Image */}
                <div className="relative mb-4 w-full h-[170px]">
                  <div
                    className="absolute inset-0 flex items-center justify-center rounded-lg"
                    style={{
                      background: `conic-gradient(#22c55e ${
                        (Array.isArray(levelProgress)
                          ? (levelProgress.find(p => p.game === "ligningsmester" && p.level === 1)?.clears || 0)
                          : 0) / 3 * 360
                      }deg, #e5e7eb 0deg)`,
                      zIndex: 0,
                    }}
                  >
                    <div className="w-40 h-40 bg-white rounded-lg flex items-center justify-center z-10">
                      <img
                        src="/images/ligningsmester_1.png"
                        alt="Ligningsmester_1"
                        className="w-40 h-40 rounded-lg object-contain"
                      />
                    </div>
                  </div>
                </div>

                {/* Button */}
                <div className="flex justify-center w-full">
                  <Link to="/Drills/ligningsmester_1">
                    <button className="px-4 py-2 bg-blue-500 text-white rounded-lg">
                      start
                    </button>
                  </Link>
                </div>
              </div>

              {/* Explainer video */}
              <div className="pt-2 w-full">
              <iframe
                src="https://player.vimeo.com/video/1104465832?h=6be7991768&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                className="border-dotted border-2 border-rose-300 rounded-xl w-full aspect-video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="ligningsmester_1_forklaring"
              />
              </div>

            </div>

            {/* Level 2 */}
            <div className="gamesWindow">

              {/* Image and button */}
              <div className="flex flex-col items-start min-w-[170px] relative mb-4">
                <h2 className="text-lg font-nunito font-semibold text-center w-full">
                  kapitel 2
                </h2>
                {/* Image */}
                <div className="relative mb-4 w-full h-[170px]">
                  <div
                    className="absolute inset-0 flex items-center justify-center rounded-lg"
                    style={{
                      background: `conic-gradient(#22c55e ${
                        (Array.isArray(levelProgress)
                          ? (levelProgress.find(p => p.game === "ligningsmester" && p.level === 2)?.clears || 0)
                          : 0) / 3 * 360
                      }deg, #e5e7eb 0deg)`,
                      zIndex: 0,
                    }}
                  >
                    <div className="w-40 h-40 bg-white rounded-lg flex items-center justify-center z-10 relative">
                      <img
                        src="/images/ligningsmester_2.png"
                        alt="Ligningsmester_2"
                        className="w-40 h-40 rounded-lg object-contain"
                      />
                    </div>
                  </div>
                </div>

                {/* Button */}
                <div className="flex justify-center w-full">
                  <Link to={
                    !profile?.badges?.some(b => b.game_name === "ligningsmester" && b.level >= 1)
                      ? "/Drills/ligningsmester"
                      : "/Drills/ligningsmester_2"
                  }>
                    <button className="px-4 py-2 bg-blue-500 text-white rounded-lg">
                     start
                    </button>
                  </Link>
                </div>
              </div>

              {/* Explainer video */}
              <div className="pt-2 w-full">
                <iframe
                  src="https://player.vimeo.com/video/1104465832?h=6be7991768&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                  className="border-dotted border-2 border-rose-300 rounded-xl w-full aspect-video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="ligningsmester_1_forklaring"
                />
              </div>

              {/* overlay */}
              {!profile?.badges?.some(b => b.game_name === "ligningsmester" && b.level >= 1) && (
                <>
                  <div className="flex absolute inset-0 bg-gray-100 opacity-40 rounded-lg justify-center items-center text-2xl text-rose-500 font-bold"/>
                  <img
                    src="/images/lock_icon.png"
                    alt="locked"
                    className="absolute top-2 left-2 w-6"
                  />
                </>
              )}
              

            </div>

            {/* Level 3 */}
            <div className="gamesWindow">

              {/* Image and button */}
              <div className="flex flex-col items-start min-w-[170px] relative mb-4">
                <h2 className="text-lg font-nunito font-semibold text-center w-full">
                  kapitel 3
                </h2>
                {/* Image */}
                <div className="relative mb-4 w-full h-[170px]">
                  <div
                    className="absolute inset-0 flex items-center justify-center rounded-lg"
                    style={{
                      background: `conic-gradient(#22c55e ${
                        (Array.isArray(levelProgress)
                          ? (levelProgress.find(p => p.game === "ligningsmester" && p.level === 3)?.clears || 0)
                          : 0) / 3 * 360
                      }deg, #e5e7eb 0deg)`,
                      zIndex: 0,
                    }}
                  >
                    <div className="w-40 h-40 bg-white rounded-lg flex items-center justify-center z-10">
                      <img
                        src="/images/ligningsmester_3.png"
                        alt="Ligningsmester_3"
                        className="w-40 h-40 rounded-lg object-contain"
                      />
                    </div>
                  </div>
                </div>

                {/* Button */}
                <div className="flex justify-center w-full">
                  <Link to="/Drills/ligningsmester">
                    <button className="px-4 py-2 bg-blue-500 text-white rounded-lg">
                      start
                    </button>
                  </Link>
                </div>
              </div>

              {/* Explainer video */}
              <div className="pt-2 w-full">
                <iframe
                  src="https://player.vimeo.com/video/1104465832?h=6be7991768&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                  className="border-dotted border-2 border-rose-300 rounded-xl w-full aspect-video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="ligningsmester_1_forklaring"
                />
              </div>

              {/* overlay */}
              <div className="flex absolute inset-0 bg-gray-100 opacity-60 rounded-3xl justify-center items-center text-2xl text-rose-500 font-bold">
                  <span className="rotate-45">kommer snart</span>
              </div>

            </div>

          </div>

          

        </div>
      </div>
    </div>
  );
}